// extracted by mini-css-extract-plugin
export default {"monochrome":"GraphGlucoseEvents_monochrome__r0s4c","high":"GraphGlucoseEvents_high__d9VcP","normal":"GraphGlucoseEvents_normal__M1a3v","low":"GraphGlucoseEvents_low__Xj2rO"};